import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

export const appbarMenuButtonItemsEnglish = [
    {title: 'My Profile', icon: <AccountCircleIcon color={'secondary'}/>, link: '/user/profile'},
    {title: 'Sign Out', icon: <LogoutOutlinedIcon color={'secondary'}/>, signout: 'signout'},
]

export const appbarMenuButtonItemsEnglishLatvian = [
    {title: 'LAT My Profile', icon: <AccountCircleIcon color={'secondary'}/>, link: '/user/profile'},
    {title: 'LAT Sign Out', icon: <LogoutOutlinedIcon color={'secondary'}/>, signout: 'signout'},
]